import { Controller } from '@hotwired/stimulus'
import { addClass, removeClass } from 'utils/toggle_class'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["filter", "item"]

  initialize() {
    this.filterItems()
  }

  filterItems() {
    // Read filter from hash. We also get rid of any other parameter that could get into the hash e.g. UTM params.
    const filterValue = window.location.hash.replace(/^#/g, "").replace(/&.*$/g, "") || "all-items"
    const matchedFilter = this.filterTargets.find((filter) => filter.dataset["filter"] === filterValue)

    if (matchedFilter) {
      // Set matchedFilter as active
      removeClass(this.filterTargets, "active")
      addClass(matchedFilter, "active")

      // Filter items
      if (filterValue === "all-items") {
        showElement(this.itemTargets)
      } else {
        hideElement(this.itemTargets)
        const matchedItems = this.itemTargets.filter((item) => item.dataset["filterValue"] === filterValue)
        showElement(matchedItems)
      }
    }
  }
}
